export const ClientPool = {
    HAVE_UPDATES: "clientpool.have_updates",
};
